/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponseOfPtw100BadRequestException,
  ErrorResponseOfPtw100MaintenanceModeException,
  LanguageCultureInfoDto,
  TimeZoneInfoDto,
} from '../models/index';
import {
    ErrorResponseOfPtw100BadRequestExceptionFromJSON,
    ErrorResponseOfPtw100BadRequestExceptionToJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionToJSON,
    LanguageCultureInfoDtoFromJSON,
    LanguageCultureInfoDtoToJSON,
    TimeZoneInfoDtoFromJSON,
    TimeZoneInfoDtoToJSON,
} from '../models/index';

export interface GetLanguageTranslationsRequest {
    lang: string;
    live?: boolean;
}

/**
 * 
 */
export class LocalizationApi extends runtime.BaseAPI {

    /**
     * Returns the translations of the given language.
     */
    async getLanguageTranslationsRaw(requestParameters: GetLanguageTranslationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['lang'] == null) {
            throw new runtime.RequiredError(
                'lang',
                'Required parameter "lang" was null or undefined when calling getLanguageTranslations().'
            );
        }


        const queryParameters: any = {};

        if (requestParameters['live'] != null) {
            queryParameters['live'] = requestParameters['live'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/localization/languages/{lang}/translations`.replace(`{${"lang"}}`, encodeURIComponent(String(requestParameters['lang']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
						if (this.isJsonMime(response.headers.get('content-type'))) {
								return new runtime.JSONApiResponse<string>(response);
						} else {
								return new runtime.TextApiResponse(response) as any;
						}
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
					default: {
						if (this.isJsonMime(response.headers.get('content-type'))) {
								return new runtime.JSONApiResponse<string>(response);
						} else {
								return new runtime.TextApiResponse(response) as any;
						}
					}
				}
				// -- Responses
    }

    /**
     * Returns the translations of the given language.
     */
     async getLanguageTranslations(requestParameters: GetLanguageTranslationsRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<LocalizationApi['getLanguageTranslationsRaw']>>, string>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = string;

         const response = this.getLanguageTranslationsRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Returns the available languages.
     */
    async getLanguagesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/localization/languages`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
						 return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LanguageCultureInfoDtoFromJSON), "LanguageCultureInfoDto" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LanguageCultureInfoDtoFromJSON));
					}
				}
				// -- Responses
    }

    /**
     * Returns the available languages.
     */
     async getLanguages(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<LocalizationApi['getLanguagesRaw']>>, Array<LanguageCultureInfoDto>>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = Array<LanguageCultureInfoDto>;

         const response = this.getLanguagesRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Returns the available time zones.
     */
    async getTimesZonesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/localization/time-zones`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
						 return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TimeZoneInfoDtoFromJSON), "TimeZoneInfoDto" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TimeZoneInfoDtoFromJSON));
					}
				}
				// -- Responses
    }

    /**
     * Returns the available time zones.
     */
     async getTimesZones(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<LocalizationApi['getTimesZonesRaw']>>, Array<TimeZoneInfoDto>>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = Array<TimeZoneInfoDto>;

         const response = this.getTimesZonesRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

}
